import React from "react";

interface AddIconProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const NewFormIcon: React.FC<AddIconProps> = ({ size = 22, color = '#0556CB', className, onClick }) => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M26.6667 3.33325H13.3333C7.5 3.33325 5 6.66658 5 11.6666V28.3333C5 33.3333 7.5 36.6666 13.3333 36.6666H26.6667C32.5 36.6666 35 33.3333 35 28.3333V11.6666C35 6.66658 32.5 3.33325 26.6667 3.33325ZM13.3333 20.4166H20C20.6833 20.4166 21.25 20.9833 21.25 21.6666C21.25 22.3499 20.6833 22.9166 20 22.9166H13.3333C12.65 22.9166 12.0833 22.3499 12.0833 21.6666C12.0833 20.9833 12.65 20.4166 13.3333 20.4166ZM26.6667 29.5833H13.3333C12.65 29.5833 12.0833 29.0166 12.0833 28.3333C12.0833 27.6499 12.65 27.0833 13.3333 27.0833H26.6667C27.35 27.0833 27.9167 27.6499 27.9167 28.3333C27.9167 29.0166 27.35 29.5833 26.6667 29.5833ZM32.5 10.5L27.5 12.9166C24.9667 12.9166 25.4167 13.3666 25.4167 10.8333V7.49992C25.4167 6.81659 24.8167 7.5 25.5 7.5C26.1833 7.5 25.4167 6.81659 25.4167 7.49992V10.8333C25.4167 11.9833 23.7418 14.1666 27.5 12.9166H30.8333C31.5167 12.9166 32.0833 13.4833 32.0833 14.1666C32.0833 14.8499 33.1833 10.5 32.5 10.5Z" fill={color} fillOpacity="0.3" />
  </svg>


);

export default NewFormIcon;
